import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { BreakpointObserverService } from '../navigation/services/breakpoint-observer.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  public isScreenSmall$: Observable<boolean>;

  @Input() showNavigation: boolean;

  constructor(
    private breakpointObserverService: BreakpointObserverService) {
    this.isScreenSmall$ = this.breakpointObserverService.isScreenSmall$;
  }

  ngOnInit(): void {
  }
}
